export type TemplateStatusTone = "positive" | "unavailable";

export interface TemplateStatusPresentation {
  label: string;
  tone: TemplateStatusTone;
}

/**
 * Centralized active/inactive presentation (redesign-panel-hubspot-mailgun,
 * PR 14 slice A, design.md §5.5 "active/inactive state") — mirrors
 * `formatting/status.ts`'s "Lifecycle mappings are centrally defined"
 * principle, but kept feature-local since `activo` is a template-specific
 * boolean, not the shared campaign lifecycle enum. Used by `TemplatesScreen`
 * (and, from PR 14 slice B onward, the routed template detail screen) so
 * "Activa"/"Inactiva" is never a second, independently-worded copy.
 */
export function resolveTemplateStatus(activo: boolean): TemplateStatusPresentation {
  return activo ? { label: "Activa", tone: "positive" } : { label: "Inactiva", tone: "unavailable" };
}
